import * as _ from 'underscore';
import * as ng from 'angular';

import { EventDetail } from '.';
import { SiteConfig } from '../shared';

import { mapStyles } from './event-map-styles';

export class EventMapController implements ng.IComponentController {
   static $inject = ['config'];

   constructor(config:SiteConfig) {
      this.apiKey = config.googleApiKey;
      this.mapStyle = mapStyles[config.settings.eventMapStyle || 1];
   }

   $onInit() {
      this.eventsByPos = _.groupBy(this.events, e => [e.lat, e.lng].join(','));
   }

   map:any;
   readonly apiKey:string;
   readonly mapStyle;
   events:EventDetail[];
   onSelectEvent:Function;
   selectedEvents:EventDetail[];
   eventsByPos:{[pos:string]:EventDetail[]};

   onMapReady(map) {
      this.map = map;
   }

   onMarkerClick(markerId:string, events:EventDetail[]) {
      this.selectedEvents = events;
      this.map.showInfoWindow('marker-events', markerId);
      this.setMarkerVisible(markerId);
   }

   // on-* events on google maps objects have `this` set to object sending event
   onInfoWindowClose(e:MouseEvent, _this:EventMapController) {
      _this.setMarkerVisible();
   }

   setMarkerVisible(hideMarkerId?:string) {
      _.each(this.map.customMarkers, (marker:any, id:string) => {
         let previous = marker.getVisible();
         marker.setVisible(id !== hideMarkerId);
         if (marker.getVisible() !== previous) {
            // when visible changes from no to yes the marker position
            // is off slightly, calling draw() appears to correct it
            marker.draw();
         }
      });
   }

   onSelect(e:EventDetail) {
      this.onSelectEvent({$event: e});
   }
}

ng.module('selfReg').component('eventMap', {
   templateUrl: require('./event-map.html'),
   controller: EventMapController,
   bindings: {
      events: '<',
      onSelectEvent: '&'
   }
})
